<template>
  <div v-if="progress.currentAction" class="progress-container">
    {{ progress.currentAction }}
    <template v-if="progress.total && progress.processed !== undefined"
      >({{ progress.processed }} {{ translate('of', 'application', 'lowercase') }} {{ progress.total }})</template
    >
    <template v-if="progress.percentage !== undefined">
      <div class="progress w-100">
        <div class="progress-bar" :style="`width: ${progressPercentage}%; ${barStyle}`">{{ progressPercentage }}%</div>
      </div>
    </template>
    <span v-else class="p-2">
      <!-- <LoaderComponent inner /> -->
      <!-- {{ progress.currentAction }} -->
      <div v-if="!progress.finished" class="spinner spinner-border spinner-border-sm refresh-spinner" />
      <i v-else class="fa fa-check" />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useTranslation } from '@/composables/useTranslation'
import { Progress } from '@/models/Global'
import { computed } from 'vue'

const props = defineProps<{ progress: Progress; barStyle?: string }>()

const { translate } = useTranslation()

const progressPercentage = computed(() => {
  if (props.progress?.percentage !== undefined) {
    return Math.ceil(props.progress.percentage)
  }
  return undefined
})
</script>

<style lang="scss" scoped>
.progress-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;

  .progress {
    font-size: 1.2em;
    height: 1.5em;
  }
}
</style>
